import { Injectable } from '@angular/core'
import { of } from 'rxjs'

import { Bet } from '../../pages/my-bets/types/my-bets.type'
import { Sport } from '../../pages/sports/types/sports.type'
import { SearchResponse } from '../components/header/types/search.type'
import { Market } from '../types/market.type'

@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	/**
	 * Get all sports
	 */
	getSports(sports: Sport[]) {
		return of(sports)
	}

	/**
	 * Get all markets
	 */
	getMarkets(markets: Market[]) {
		return of(markets)
	}

	/**
	 * Get all search results
	 */
	getSearchResults(searchResponse: SearchResponse) {
		return of(searchResponse)
	}

	getBets(bets: (Bet & { navIds?: string[] })[]) {
		return of(bets)
	}
}
